/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Card/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import No from './No/index'
import PlatformFee from './PlatformFee/index'
import React from 'react'
import Standard from './Standard/index'
import Surcharge from './Surcharge/index'



/** @type {import('Simple/types.js').View} */
export default function Card({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderLocation/PlatformFeeWarning/Content/AcknowledgementText/Card",
  amount
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let paymentFeeModeValueData = fromData.useDataValue({ viewPath,
context: 'payment',
path: 'fee_mode',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: paymentFeeModeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Standard'}>
<Standard
  viewPath={`${viewPath}/Standard`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PlatformFee'}>
<PlatformFee
  viewPath={`${viewPath}/PlatformFee`}
 amount={amount}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Surcharge'}>
<Surcharge
  viewPath={`${viewPath}/Surcharge`}
 amount={amount}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}